import React from 'react';

import dayjs, { dateDisplayFormat } from '~libs/dayjs';

import { ClickableIcon, Spinner } from '~components';
import { faRefresh } from '~components/icon';

interface Row {
  id: string | number;
  is_validating: boolean;
  validated_at?: string;
  status?: { tag?: string };
}

interface ComponentProps {
  row: Row;
  validateClaim: (id: string | number) => void;
}

const ValidationStatus: React.FC<ComponentProps> = ({ row, validateClaim }) => {
  const { is_validating, validated_at, status } = row;
  const isFinalised = status?.tag === 'finalised';

  if (is_validating) {
    return (
      <div className="d-flex justify-content-end align-items-center">
        <span className="fw-bold text-secondary">Validating...</span>
        <Spinner className="ms-4" type="beat" size={8} loading={true} />
      </div>
    );
  }

  const formattedDate = validated_at ? dayjs(validated_at).format(dateDisplayFormat) : 'Not validated';
  const notValidated = !validated_at;

  return (
    <div className="d-flex justify-content-end align-items-center">
      <span className={notValidated ? 'fw-bold text-danger' : ''}>{formattedDate}</span>
      <ClickableIcon
        id={`${row.id}-validate-claim`}
        icon={faRefresh}
        className="ms-4 text-primary"
        onClick={() => validateClaim(row.id)}
        toolTip={isFinalised ? 'Cannot validate finalised claim' : 'Validate Now'}
        disabled={isFinalised}
        showTooltipWhenDisabled={true}
      />
    </div>
  );
};

export default ValidationStatus;
